import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, BookOpen, Brain, Zap, ArrowRight } from 'lucide-react';
export function ProductPromise() {
  const cards = [{
    icon: Stethoscope,
    title: 'Procedimientos paso a paso',
    desc: 'Cada técnica clínica explicada con orden, criterio y seguridad real.',
    preview: 'Cómo actuar frente al paciente'
  }, {
    icon: BookOpen,
    title: 'Protocolos y farmacología',
    desc: 'Pautas, cálculos, dosis, diluciones y red flags en un solo lugar.',
    preview: 'Cómo no equivocarte con la medicación'
  }, {
    icon: Brain,
    title: 'Razonamiento clínico aplicado',
    desc: 'Casos resueltos que te enseñan a priorizar y pensar como enfermería real.',
    preview: 'Qué priorizar primero'
  }, {
    icon: Zap,
    title: 'Pensado para práctica real',
    desc: 'Material que usás antes del turno, en internado y para parciales.',
    preview: 'Cómo relacionar teoría con clínica'
  }];
  return <section className="relative py-12 md:py-20 lg:py-24 bg-clinical-base overflow-hidden" data-id="element-409">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[44rem] h-[44rem] bg-clinical-softer rounded-full blur-[140px] opacity-50 pointer-events-none" data-id="element-410"></div>

      <div className="relative max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-411">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14" data-id="element-412">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[10px] sm:text-xs font-semibold tracking-[0.22em] uppercase text-clinical-mid mb-4" data-id="element-413">
            Más que un pack
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl sm:text-4xl md:text-5xl font-black text-clinical-deep mb-4 leading-[1.05] uppercase" data-id="element-414">
            No es solo un{' '}
            <span className="accent-italic normal-case" data-id="element-415">pack de apuntes</span>
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-sm md:text-lg text-clinical-ink leading-relaxed" data-id="element-416">
            Es un sistema clínico pensado para ayudarte a{' '}
            <span className="accent-italic" data-id="element-417">
              relacionar teoría con práctica real
            </span>{' '}
            y actuar con claridad frente al paciente.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5" data-id="element-418">
          {cards.map((card, idx) => {
          const Icon = card.icon;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.08
          }} className="group relative bg-white rounded-2xl p-5 md:p-7 border border-clinical-line hover:border-clinical-mid/40 hover:-translate-y-1 hover:shadow-[0_20px_48px_rgba(11,42,74,0.10)] transition-all overflow-hidden" data-id="element-419">
                <div className="absolute top-0 right-0 w-32 h-32 bg-clinical-softer rounded-full blur-3xl opacity-0 group-hover:opacity-80 transition-opacity pointer-events-none" data-id="element-420"></div>

                <div className="relative flex items-start gap-4 md:gap-5" data-id="element-421">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-clinical-base border border-clinical-line flex items-center justify-center flex-shrink-0 shadow-sm" data-id="element-422">
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-clinical-mid" strokeWidth={2} data-id="element-423" />
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-424">
                    <h3 className="text-base md:text-lg font-bold text-clinical-deep mb-2 leading-snug uppercase" data-id="element-425">
                      {card.title}
                    </h3>

                    <p className="text-sm text-clinical-ink/80 leading-relaxed mb-3" data-id="element-426">
                      {card.desc}
                    </p>

                    {/* Mini preview chip — utility hint */}
                    <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-clinical-base border border-clinical-line text-[10px] font-bold tracking-[0.12em] uppercase text-clinical-mid" data-id="element-427">
                      <ArrowRight className="w-3 h-3" strokeWidth={2.5} data-id="element-428" />
                      {card.preview}
                    </div>
                  </div>
                </div>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}